// extracted by mini-css-extract-plugin
export default {"client":"clientLink_client__DhMO8"};